'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
    async getDepartments() {
        const data = {
            method: 'get',
            url: 'departments',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getDepartmentNextNo() {
        const data = {
            method: 'get',
            url: 'departmentNextNo',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createDepartment(json) {
        const data = {
            method: 'post',
            url: 'department',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Department created successfully')
            return true;
        }
    },
    async updateDepartment(json, id) {
        const data = {
            method: 'patch',
            url: 'department/' + id,
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Department updated successfully')
            return true;
        }
    },
}
